module.exports = __webpack_public_path__ + "img/precious04.69d34866.jpg";